import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_JOBS_API } from "./apiRoutes";
interface UseGetJobByIdProps {
  communityId: string;
  jobId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getJobById = async (jobId: string, communityId: string) =>
  await axiosAuth.get(`${DISTRIBUTION_JOBS_API(communityId)}/${jobId}`);

const useGetJobById = ({
  queryParams,
  jobId,
  communityId
}: UseGetJobByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-job-by-id", jobId],
    queryFn: () => getJobById(jobId, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!jobId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetJobById;
